import { render } from "./collegeCase.vue?vue&type=template&id=0d353404&scoped=true"
import script from "./collegeCase.vue?vue&type=script&lang=js"
export * from "./collegeCase.vue?vue&type=script&lang=js"

import "./collegeCase.vue?vue&type=style&index=0&id=0d353404&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-service/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d353404"]])

export default __exports__